import { useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import { useCallback, useEffect, useState } from 'react';
import { urlBaseCore } from '../../../../../Utils/Services';
import { carregarResumoDia, dataBrasilia, ResumoDia } from './resumoDia';

export default function useResumoDia(loja: string, permitido: boolean) {
  const [ativo, setAtivo] = useState(false);
  const [revisao, setRevisao] = useState(0);
  const [estado, setEstado] = useState<{ loja: string; dia: string; resumo?: ResumoDia; carregando: boolean; erro: boolean }>({ loja: '', dia: dataBrasilia(), carregando: false, erro: false });
  const atualizar = useCallback(() => setRevisao(valor => valor + 1), []);
  // A entrada já dispara o efeito ao ativar a tela. Incrementar também a
  // revisão aqui reinicia a busca no ReactDOM.render, que não agrupa as
  // atualizações disparadas pelo ciclo de vida nativo do Ionic.
  useIonViewDidEnter(() => setAtivo(true), []);
  useIonViewWillLeave(() => setAtivo(false), []);

  useEffect(() => {
    if (!ativo || !loja || !permitido) return;
    const controller = new AbortController();
    const dia = dataBrasilia();
    setEstado({ loja, dia, carregando: true, erro: false });
    carregarResumoDia(urlBaseCore.url, loja, localStorage.getItem('token') || '', dia, controller.signal)
      .then(resumo => { if (!controller.signal.aborted) setEstado({ loja, dia, resumo, carregando: false, erro: false }); })
      .catch(() => { if (!controller.signal.aborted) setEstado({ loja, dia, carregando: false, erro: true }); });
    return () => controller.abort();
  }, [ativo, loja, permitido, revisao]);

  return { ...estado, resumo: permitido && estado.loja === loja ? estado.resumo : undefined, atualizar };
}
